import { useEffect, useState } from 'react';

export const useIntersection = (element, rootMargin, threshold, multipleObserve = false) => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(entry.isIntersecting);
          if (!multipleObserve) {
            observer.unobserve(element.current);
          }
        }
      },
      { rootMargin, threshold }
    );
    if (element && element.current) {
      observer.observe(element.current);
    }
    return () => observer.unobserve(element.current);
  }, []);

  return isVisible;
};
